import React from 'react';

export const OWASPIcon = () => {
  return (
    <div style={{ width: 300, height: 90 }}>
      <img style={{ width: 300, height: 90 }} src="/pictures/OWASPIcon.png" alt="" />
    </div>
  );
};
